import { partfinitiClient } from 'core/services';
import { IUpsertPartBomItemNotePayload } from 'partBoms/types';

export const upsertPartBomItemNote = async (data: IUpsertPartBomItemNotePayload) =>
  await partfinitiClient.postForm('/part_v2/bom-item-note-edit/save', data);

export const removePartBomItemNotes = async (data: { ids: number[] }) =>
  await partfinitiClient.postForm('/part_v2/bom-item-note-edit/remove', data);
